import { notification } from "antd";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { Api } from "../../common/Api";
import { Employee } from "../../store/domains/Employee";

export const useEditEmployee = ({ refresh }) => {
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [resending, setResending] = useState(false);
  const [setting, setSetting] = useState(false);
  const [model, setModel] = useState<Employee>(new Employee());

  const add = () => {
    setModel(new Employee());
    setVisible(true);
  };

  const edit = (id) => {
    setModel(new Employee());
    setVisible(true);
    Api.employee.get(id).then((res) => {
      setModel(res.data.employee);
    });
  };

  const save = (values) => {
    setSaving(true);
    return Api.employee
      .save({ id: model.id, ...values })
      .then((res) => {
        setVisible(false);
        notification.success({ message: `Employee ${values.firstName} ${values.lastName} saved` });
        refresh();
      })
      .catch((err: ApolloError) => {})
      .finally(() => setSaving(false));
  };

  const resend = () => {
    setResending(true);
    return Api.employee
      .resend(model.id)
      .then(() => {
        notification.success({ message: `Employee ${model.firstName} ${model.lastName} invitation resent` });
      })
      .catch((err: ApolloError) => {})
      .finally(() => setResending(false));
  };
  const enabled = () => {
    setSetting(true);
    return Api.employee
      .setEnabled(model.id, !model.poolInfo.enabled)
      .then(() => {
        notification.success({ message: `Employee ${model.firstName} ${model.lastName} enabled` });
        setModel({ ...model, poolInfo: { ...model.poolInfo, enabled: !model.poolInfo.enabled } });
        refresh();
      })
      .catch((err: ApolloError) => {})
      .finally(() => setSetting(false));
  };

  const close = () => {
    setVisible(false);
  };

  return {
    visible,
    saving,
    model,
    edit,
    save,
    close,
    add,
    resend,
    resending,
    enabled,
    setting,
  };
};
